module.exports = __webpack_public_path__ + "static/media/mariana-falcao-avatar.473a2233.svg";